import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <span className="footer-brand">OneJob</span>
        <span className="footer-copy">&copy; 2026 OneJob. Part-time jobs for international students in Korea.</span>
      </div>
    </footer>
  );
}

export default Footer;
